import {
  createPermission,
} from '@backstage/plugin-permission-common';

export const feedbackCreatePermission = createPermission({
  name: 'feedback-common.feedback.create',
  attributes: { action: 'create' },
});

export const feedbackDeletePermission = createPermission({
  name: 'feedback-common.feedback.delete',
  attributes: { action: 'delete' },
});

export const feedbackListPermission = createPermission({
  name: 'feedback-common.feedback.read',
  attributes: { action: 'read' },
});

export const npsReadPermission = createPermission({
  name: 'feedback-common.nps.read',
  attributes: { action: 'read' },
});

export const feedbackPermissions: any[] = [
  feedbackCreatePermission,
  feedbackDeletePermission,
  feedbackListPermission,
  npsReadPermission,
];
